<template>
  <div>
    <div class="row">
      <h2>Lexicon suggestions list <b>({{this.desc}})</b></h2>
    </div>

    <div class="row float-right">
      <div class="col-md-12"><br /><br /><br />
        <label class="btn btn-secondary" @click.stop="onSaveSuggestions()">
          Save suggestions
        </label>&nbsp;

        <label class="btn btn-info" @click.stop="onBuildSuggestions()">
          Submit build
        </label>&nbsp;
      </div>
    </div><br /><br /><br />

    <div class="row d-flex justify-content-center">
      <div v-if="this.requestCompleted && this.rows.length === 0">
        Suggestions list is empty.<br />
      </div>
    </div>

    <div v-if="this.rows.length > 0">
      <grid :styles="gridStyle" :cols="cols" :rows="rows" :sort="true" :pagination="pagination" :search="search"></grid>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import Grid from 'gridjs-vue'
import router from '../router'

export default {
  props: {
  },
  components: {
    Grid
  },
  data () {
    return {
      desc: {},
      rows: [],
      requestCompleted: false,
      groupId: 0,
      pagination: true,
      search: true,
      gridStyle: {
        table: {
          border: '3px solid #ccc'
        },
        th: {
          'background-color': 'rgba(0, 0, 0, 0.1)',
          color: '#000',
          'border-bottom': '3px solid #ccc',
          'text-align': 'center'
        },
        td: {
          'text-align': 'center'
        }
      },
      cols: [
        {
          name: 'User word',
          formatter: (cell, row) => {
            return this.$gridjs.html('<span style="color: green"><u>' + cell + '</u></span>')
          }
        },
        {
          name: 'Word suggestions',
          formatter: (cell) => this.$gridjs.html('<span><u>' + cell + '</u></span>')
        },
        {
          name: 'Actions',
          sort: false,
          formatter: (cell, row) => {
            const editAction = this.$gridjs.h(
              'span',
              { onClick: () => this.editLexiconWord(row) },
              this.$gridjs.html(
                '<svg style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg>'
              )
            )
            return [editAction, ' ']
          }
        }
      ]
    }
  },
  mounted: function () {
    this.groupId = this.$route.params.id

    apiClient.get('/api/lexicons/item/' + this.groupId).then((response) => {
      this.desc = response.data.group[0].lexicon_description
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })

    apiClient.get('/api/lexicon/suggest/' + this.groupId).then((response) => {
      console.log(response)
      response.data.forEach((item, key) => {
        this.rows.push([
          item.lexicon_id,
          item.request_date,
          item.status,
          item.id
        ])
      })
      this.requestCompleted = true
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })
  },
  methods: {
    navigateToLexiconWordsList: function () {
      router.push({ name: 'LexiconWords', params: { id: this.groupId } })
    },
    onManageSuggestions: function (event) {
      router.push({ name: 'LexiconSuggestionsManagement', params: { id: this.groupId } })
    }
  }
}
</script>
